import { render } from "./schedules.vue?vue&type=template&id=40a3145c"
import script from "./schedules.vue?vue&type=script&lang=js"
export * from "./schedules.vue?vue&type=script&lang=js"

import "./schedules.vue?vue&type=style&index=0&id=40a3145c&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__